var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAllowedForAdminView())?_c('Administrator'):(_vm.$store.state.user?.role === 'speaker')?_c('Speaker'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }